import { List, fromJS } from 'immutable';
import { createSelector } from 'reselect';
import { getReportTemplates } from '../../api/reportTemplatesApi';
import { RequestState } from 'dashboard-lib/public/request/request-state';
const {
  UNINITIALIZED,
  PENDING,
  SUCCEEDED,
  FAILED
} = RequestState;
export const readyMadeReportSearchNamespace = 'readyMadeReportSearch';

// Action types
const FETCH_READY_MADE_REPORTS_PENDING = 'FETCH_READY_MADE_REPORTS_PENDING';
const FETCH_READY_MADE_REPORTS_SUCCEEDED = 'FETCH_READY_MADE_REPORTS_SUCCEEDED';
const FETCH_READY_MADE_REPORTS_FAILED = 'FETCH_READY_MADE_REPORTS_FAILED';
// Actions
export const searchReadyMadeReports = search => dispatch => {
  dispatch({
    type: FETCH_READY_MADE_REPORTS_PENDING
  });
  return getReportTemplates({
    filterSearch: search
  }).then(templatesList => {
    dispatch({
      type: FETCH_READY_MADE_REPORTS_SUCCEEDED,
      payload: templatesList
    });
  }).catch(exception => {
    if ((exception === null || exception === void 0 ? void 0 : exception.errorCode) !== 'ABORT') {
      console.error(exception);
      dispatch({
        type: FETCH_READY_MADE_REPORTS_FAILED
      });
    }
  });
};
// Reducers
const initialState = fromJS({
  status: UNINITIALIZED,
  templates: List()
});
export const readyMadeReportSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_READY_MADE_REPORTS_PENDING:
      return state.set('status', PENDING);
    case FETCH_READY_MADE_REPORTS_SUCCEEDED:
      return state.merge({
        status: SUCCEEDED,
        templates: action.payload
      });
    case FETCH_READY_MADE_REPORTS_FAILED:
      return state.set('status', FAILED);
    default:
      return state;
  }
};

// Selectors
export const selectReadyMadeReportSearchRoot = state => state[readyMadeReportSearchNamespace];
export const selectReadyMadeReportTemplates = createSelector(selectReadyMadeReportSearchRoot, readyMadeReportSearchRoot => readyMadeReportSearchRoot.get('templates'));
export const selectIsReadyMadeReportSearchLoading = createSelector(selectReadyMadeReportSearchRoot, readyMadeReportSearchRoot => readyMadeReportSearchRoot.get('status') === PENDING);
export const selectIsReadyMadeReportSearchFailed = createSelector(selectReadyMadeReportSearchRoot, readyMadeReportSearchRoot => readyMadeReportSearchRoot.get('status') === FAILED);